export const ARABIC_SYMBOLS: Record<string, string> = {
  AED: '\u{E901}',
  SAR: '\u{E900}',
};
